import { gql } from '@apollo/client';

export default gql`
  mutation missedDeparture($reference: String!, $exchangeItems: [Int]!, $shouldAllowNextDay: Boolean = false) {
    missedDeparture(reference: $reference, exchangeItems: $exchangeItems, shouldAllowNextDay: $shouldAllowNextDay) {
      updatedBooking {
        reference
        totalPriceToBePaid: totalPriceToBePaidWithCurrency
        totalPendingCancellationFarePrice: totalPendingCancellationFarePriceWithCurrency
        totalPendingCreationFarePrice
        totalExchangeFee: totalExchangeFeeWithCurrency
        fees {
          code
          name
          price
          cancelled
          provisional
        }
        pendingCancellationLegs {
          ...pendingLeg
        }
        pendingCreationLegs {
          ...pendingLeg
        }
      }
      nextAvailableTrain {
        trainNumber
        serviceIdentifier
        recommendedSeats {
          coach
          number
        }
      }
    }
  }

  fragment pendingLeg on Leg {
    direction
    fees {
      price
      cancelled
      provisional
    }
    bookingItems: products {
      price
      cancelled
      provisional
    }
  }
`;
